import type { Theme } from "../types/Theme";
import { themeOptionalColorString } from "../utils";

/** Modern nav chrome only when {@link Theme.UseModernTheme} is strictly true. */
export function shouldUseModernTheme(theme: Theme): boolean {
    return theme.UseModernTheme === true;
}

/**
 * Focus ring for modern primary/outline buttons (inset border + white gap + outer halo).
 * Matches {@link Button.styles.ts} `modernButtonFocusPseudoStyles`.
 */
export function resolveModernButtonFocusBoxShadow(theme: Theme): string {
    const gap = theme.WhiteColor ?? "#ffffff";
    const ring = theme.PrimaryColor;
    const inset = `0 0 0 ${theme.BorderWidth}px ${ring} inset`;
    return `${inset}, 0 0 0 2px ${gap}, 0 0 0 4px ${ring}`;
}

/** Focus halo for compact icon controls without an inset border. */
export function resolveModernCompactFocusBoxShadow(theme: Theme): string {
    const gap = theme.WhiteColor ?? "#ffffff";
    const ring = theme.PrimaryColor;
    return `0 0 0 2px ${gap}, 0 0 0 4px ${ring}`;
}
